export default {
  showLoading: function (title, duration = 2000) {
    const toastDiv = document.querySelector('#my-loading-box');
    const toastTitleDiv = document.querySelector('#my-loading-title');
    if (title) {
      toastTitleDiv.innerHTML = title;
      toastTitleDiv.style = 'display: block';
    }
    toastDiv.style = 'display: block';
  },
  hideLoading: function () {
    const toastDiv = document.querySelector('#my-loading-box');
    const toastTitleDiv = document.querySelector('#my-loading-title');
    toastTitleDiv.innerHTML = '';
    toastTitleDiv.style = 'display: none';
    toastDiv.style = 'display: none';
  },
};
